import { schema } from 'normalizr';

export const rate = new schema.Entity(
  'ratesGraph',
  {},
  {
    idAttribute: 'date',
  }
);
export const rateTime = new schema.Entity(
  'ratesGraph',
  {},
  {
    idAttribute: item => {
      return item?.time || item?.date;
    },
  }
);

export const ratesGraph = [rate];
export const ratesTimeGraph = [rateTime];
